import client from '../client';
import * as underwriterRateMutations from "../mutations/underwriterRate";
import * as underwriterRateQueries from "../queries/underwriterRate";

export function getRates(success, error, companyId, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        variables: { companyId: companyId },
        query: underwriterRateQueries.all,
    })
        .then(success)
        .catch(error);
}

export function add(success, error, data) {
    client.mutate({
        variables: { underwriterRate: data },
        mutation: underwriterRateMutations.add,
    }).then(success).catch(error);;
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, underwriterRate: data },
        mutation: underwriterRateMutations.edit,
    }).then(success).catch(error);
}


export function remove(success, error, id) {
    client.mutate({
        variables: { id: id },
        mutation: underwriterRateMutations.remove,
    }).then(success).catch(error);
}




// WEBPACK FOOTER //
// ./src/graphql/actions/underwriterRate.js